"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dragDrop = require("./drag-drop");

require("./item-selector.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const ItemSelector = _ref => {
  let {
    items = [],
    selectedItems,
    setSelectedItems
  } = _ref;
  const dragListItems = items; // allow each item only once:
  // const dragListItems = items.filter(s => !selectedItems.map(si => si.icon).includes(s.icon))

  const [moving, setMoving] = (0, _react.useState)(false);

  const addToList = function (item) {
    let pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "end";
    let newSelectedItems = selectedItems.filter(i => i.uid !== item.uid);
    const newItem = { ...item,
      uid: new Date().getTime()
    };
    const targetPos = pos === "end" ? newSelectedItems.length : pos;
    newSelectedItems.splice(targetPos, 0, newItem);
    setSelectedItems(newSelectedItems);
  };

  const removeFromList = uid => {
    setSelectedItems([...selectedItems.filter(i => i.uid !== uid)]);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__item-selector"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__drag-list"
  }, dragListItems.map((item, i) => {
    item = { ...item,
      uid: i
    };
    return /*#__PURE__*/_react.default.createElement(_dragDrop.Draggable, {
      key: i,
      dragData: item,
      onDragStart: () => setMoving(true),
      onDragEnd: () => setMoving(false)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `donation-encourager__item`,
      onClick: () => addToList(item)
    }, renderIcon(item.icon)));
  })), /*#__PURE__*/_react.default.createElement(_dragDrop.DropTarget, {
    onDropLeft: dragItem => addToList(dragItem, 0),
    onDropRight: addToList // adds item to the end

  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `donation-encourager__drop-target-container${moving ? " highlighted" : ""}`
  }, selectedItems.map((item, i) => /*#__PURE__*/_react.default.createElement(_dragDrop.DropTarget, {
    key: i,
    onDropLeft: dragItem => addToList(dragItem, i),
    onDropRight: dragItem => addToList(dragItem, i + 1)
  }, /*#__PURE__*/_react.default.createElement(_dragDrop.Draggable, {
    dragData: item
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `donation-encourager__item`,
    onClick: () => removeFromList(item.uid)
  }, renderIcon(item.icon))))))));
};

var _default = ItemSelector;
exports.default = _default;

function renderIcon(icon) {
  // return typeof icon === "object" ? <FontAwesomeIcon icon={icon} /> : icon
  return icon;
}